import type { DeepReadonly } from "vue";

import { v4 as createUuid } from "uuid";

import { sSessionStorage } from "@solvari/utils";

import type { ArgusEvent, ArgusEvents } from "@/service/backendSync";

import { scheduleBackendSync } from "@/service/backendSync";

declare global {
  // oxlint-disable-next-line typescript/consistent-type-definitions
  interface Window {
    argusClient?: {
      createArgusEvent?: typeof createArgusEvent;
    };
  }
}

function createArgusEvent<Type extends keyof ArgusEvents>(
  type: Type,
  data: DeepReadonly<ArgusEvents[Type]>,
): ReturnType<typeof scheduleBackendSync> {
  if (!window.argusClient) {
    window.argusClient = {};
  }
  if (!window.argusClient.createArgusEvent) {
    window.argusClient.createArgusEvent = (type, data) => {
      const event = {
        type,
        data,
        uuid: createUuid(),
        createdAt: new Date().toISOString(),
        status: "unsynced",
        syncAttempts: [],
      } satisfies ArgusEvent;

      sSessionStorage.updateItem("argusEvents", (events) => {
        return events ? [...events, event] : [event];
      });

      return scheduleBackendSync();
    };
  }

  return window.argusClient.createArgusEvent(type, data);
}

export { createArgusEvent };
